/**
 * Tabbed Products
 * – Desktop: tab switching
 * – Mobile: per-block slider with dot pagination + touch/swipe
 * Product card ATC is handled by the theme's native product-form element.
 */
(function () {
  'use strict';

  /* ── Desktop Tab Switching ──────────────────────────── */
  document.querySelectorAll('.tabbed-products-section').forEach((section) => {
    const tabs   = section.querySelectorAll('.tabbed-products__tab');
    const panels = section.querySelectorAll('.tabbed-products__panel');

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        tabs.forEach((t) => { t.classList.remove('is-active'); t.setAttribute('aria-selected', 'false'); });
        panels.forEach((p) => p.classList.remove('is-active'));
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');
        const target = section.querySelector('#' + tab.getAttribute('aria-controls'));
        if (target) target.classList.add('is-active');
      });
    });
  });

  /* ── Mobile Slider ──────────────────────────────────── */
  function initSlider(sliderEl, dotsEl) {
    const track  = sliderEl.querySelector('.tp-mobile-slider__track');
    const slides = sliderEl.querySelectorAll('.tp-mobile-slide');
    if (!track || slides.length <= 1) return;

    let current = 0;
    let startX  = 0;
    let isDragging = false;

    // Build dots
    dotsEl.innerHTML = '';
    slides.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.className = 'tp-mobile-dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      dot.addEventListener('click', () => goTo(i));
      dotsEl.appendChild(dot);
    });

    function goTo(idx) {
      current = Math.max(0, Math.min(idx, slides.length - 1));
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      dotsEl.querySelectorAll('.tp-mobile-dot').forEach((d, i) => {
        d.classList.toggle('is-active', i === current);
      });
    }

    // Touch swipe
    track.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; isDragging = true; }, { passive: true });
    track.addEventListener('touchend', (e) => {
      if (!isDragging) return;
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) goTo(diff > 0 ? current + 1 : current - 1);
      isDragging = false;
    }, { passive: true });

    // Mouse drag (for desktop preview)
    track.addEventListener('mousedown', (e) => { startX = e.clientX; isDragging = true; });
    window.addEventListener('mouseup', (e) => {
      if (!isDragging) return;
      const diff = startX - e.clientX;
      if (Math.abs(diff) > 40) goTo(diff > 0 ? current + 1 : current - 1);
      isDragging = false;
    });
  }

  function initAllSliders() {
    document.querySelectorAll('.tp-mobile-slider').forEach((slider) => {
      const id   = slider.dataset.sliderId;
      const dots = document.querySelector('[data-dots-for="' + id + '"]');
      if (dots) initSlider(slider, dots);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSliders);
  } else {
    initAllSliders();
  }

})();
